import axiosRequest from "@/utils/request"
export const grandRequest = (obj) => {
    if (obj?.data === true || obj?.auth_type === true){
        return obj.auth_url || `${obj.url}:${(obj.method).toUpperCase()}`;
    }else{
        if(obj?.auth_url) delete obj.auth_url;
        if(obj?.auth_type) delete obj.auth_type;
        return axiosRequest(obj);
    }
}
export const login = (account, password) =>
    grandRequest({
        url: '/login',
        method: 'post',
        data: {account, password},
    })
export const getMenu = (data) =>
    grandRequest({
        url: '/menu',
        method: 'get',
        params:data,
    })
export const getAuth = (data) =>
    grandRequest({
        url: '/auth',
        method: 'get',
        params:data,
    })
export const getProfile = (data) =>
    grandRequest({
        url: '/profile',
        method: 'get',
        params:data,
    })
export const aliOssToken = (data) =>
    grandRequest({
        url: '/ali-oss-token',
        method: 'get',
        params:data,
    })
export const changePass = (data) =>
    grandRequest({
        url: '/change-pass',
        method: 'post',
        data,
    })
